export default __webpack_public_path__ + "static/playButton-aac01521a1e5f8ad05c37f4f3b54140b.png";